'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.postConversationStartedEvent = undefined;

var _postExternalApiEvent = require('../../external-api-events/actions/postExternalApiEvent');

var _externalApiEventTypes = require('../../external-api-events/constants/externalApiEventTypes');

var _serializeThreadForExternalEvent = require('../../external-api-events/util/serializeThreadForExternalEvent');

var postConversationStartedEvent = exports.postConversationStartedEvent = function postConversationStartedEvent(_ref) {
  var thread = _ref.thread;
  return function (dispatch) {
    dispatch((0, _postExternalApiEvent.postExternalApiEvent)({
      eventType: _externalApiEventTypes.CONVERSATION_STARTED,
      payload: {
        conversation: (0, _serializeThreadForExternalEvent.serializeThreadForExternalEvent)(thread)
      }
    }));
  };
};


//////////////////
// WEBPACK FOOTER
// ./js/threads/actions/postConversationStartedEvent.js
// module id = 526
// module chunks = 2 3